import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "intersection-observer";
import { InView } from "react-intersection-observer";
import PdfSubmission from "../PdfSubmission/PdfSubmission";
import HSInlineForm from "../HSInlineForm/HSInlineForm";

const ArticleSection = (props) => {
  const {
    //article = null,
    contentId = null,
    matchedCategoryIds = null
    //order = "first" //which lazy loaded article on the page is it?
  } = props;

  const [sectionData, setSectionData] = useState(null);
  const sectionRef = useRef(null);

  // fetchSection is fetching ads
  const fetchSection = () => {
    if (sectionData) {
      refreshAds(sectionRef.current.querySelectorAll("[data-zone]"));
    }
  };

  const loadArticle = () => {
    if (contentId === "undefined") {
      return;
    }
    axios
      .get("/api/v2/article-section", {
        params: {
          contentId: contentId,
          matchedCategoryIds: matchedCategoryIds
        }
      })
      .then((response) => {
        setSectionData(response.data.length ? response.data : null);

        if (sectionRef.current && response.data.length) {
          sectionRef.current.classList.remove("isEmpty");
          sectionRef.current.classList.add("isLoaded");

          // add article to url updater
          let article = sectionRef.current.querySelector("#ArticleView");
          if (!article) article = sectionRef.current.querySelector("#ConversionPageView");
          let handleAttachedArticleEvent = new CustomEvent("handleAttachedArticle", { detail: article });

          window.dispatchEvent(handleAttachedArticleEvent);
        }
      })
      .catch((error) => {
        // No need to do anything
      });
  };

  useEffect(() => {
    if (!sectionData) {
      loadArticle();
    }
  });

  useEffect(() => {
    if (sectionData) {
      /** Handle React PdfSubmission in dangerouslySetInnerHTML*/
      const title = sectionData
        .match(/data-title="[^"]*"/)[0]
        .split(/["]/)
        .slice(-2, -1)[0];
      const articleNo = parseInt(
        sectionData
          .match(/data-articleNo="\d+"/)[0]
          .split(/["]/)
          .slice(-2, -1)[0]
      );
      const articleDom = document.querySelector(`[data-articleno="${articleNo}"]`);
      const PdfSubmissionContainer = articleDom.querySelector("#PdfSubmissionContainer");
      if (PdfSubmissionContainer) {
        ReactDOM.hydrate(<PdfSubmission article={{ articleNo, title }} />, PdfSubmissionContainer);
      }
      /** Handle React HSInlineForm ub dangerouslySetInnerHTML */
      const formdata = articleDom.getAttribute("data-formdata");
      const siteFullName = articleDom.getAttribute("data-siteFullName");
      const hasRelatedConversion = articleDom.getAttribute("data-hasRelatedConversion") || false;
      const HSInlineFormDom = articleDom.querySelector("#HSInlineForm");
      if (HSInlineFormDom) {
        ReactDOM.hydrate(
          <HSInlineForm formdata={formdata} siteFullName={siteFullName} hasRelatedConversion={hasRelatedConversion} />,
          HSInlineFormDom
        );
      }
      /** Handle React CurrentIssue */
      const currentIssue = document.querySelector(`.articleSection:has([data-articleno="${articleNo}"]) .CurrentIssue`);
      if (currentIssue) {
        axios
          .get("/api/v2/current-issue", {
            params: {
              issidebar: true
            }
          })
          .then((response) => {
            currentIssue.innerHTML = response.data;
          });
      }
    }
  }, [sectionData]);

  const refreshAds = (adSlots) => {
    let loadNewAdsEvent = new CustomEvent("loadNewAds", { detail: adSlots });

    window.dispatchEvent(loadNewAdsEvent);
  };

  const createMarkup = () => {
    return {
      __html: sectionData
    };
  };

  return (
    <div ref={sectionRef}>
      <InView rootMargin="0% 0% 75%" triggerOnce={true} onChange={(inView, entry) => inView && fetchSection()}>
        <div dangerouslySetInnerHTML={createMarkup()} />
      </InView>
    </div>
  );
};

export default ArticleSection;
